// Importa los métodos necesarios de Firebase
import { initializeApp } from 'firebase/app';
import { 
  query,
  getFirestore, 
  collection, 
  doc, 
  addDoc,
  setDoc, 
  getDoc, 
orderBy,
  updateDoc, 
  onSnapshot, 
  writeBatch,
  Timestamp, 
  where,
  getDocs,
  deleteDoc
} from 'firebase/firestore';
import { 
  getAuth, 
  GoogleAuthProvider, 
  signInWithRedirect,  // Cambiar esto
  signOut, 
  getRedirectResult  // Importar getRedirectResult
} from 'firebase/auth';

// Configuración de Firebase
const firebaseConfig = {
  apiKey: "AIzaSyAgjkeGTL4suLhVFbSbKq9ivf5b60aj00Q",
  authDomain: "truebabd-e2a6b.firebaseapp.com",
  projectId: "truebabd-e2a6b",
  storageBucket: "truebabd-e2a6b.firebasestorage.app",
  messagingSenderId: "370471872238",
  appId: "1:370471872238:web:f3e6855c1d03840fdcb5ff",
  measurementId: "G-JVPQNQP9V3"
};

// Inicializa Firebase
const app = initializeApp(firebaseConfig);

// Inicializa Firestore
const db = getFirestore(app);

// Inicializa Firebase Authentication
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

// Función para iniciar sesión con Google usando redirección
const signInWithGoogle = async () => {
  try {
    await signInWithRedirect(auth, provider);  // Usamos redirección en lugar de popup
  } catch (error) {
    console.error("Error al iniciar sesión con Google:", error);
    throw error;  // Lanza el error para manejarlo donde se llame
  }
};

// Función para obtener el resultado de la redirección (usada cuando el usuario regresa a la app)
const getUserFromRedirect = async () => {
  try {
    const result = await getRedirectResult(auth);  // Obtiene el resultado de la redirección
    if (result) {
      return result.user;  // Devuelve el usuario autenticado
    }
    return null;  // Si no hay resultado, no hay usuario autenticado
  } catch (error) {
    console.error("Error al obtener el resultado de la redirección:", error);
    throw error;
  }
};

// Función para cerrar sesión
const logout = async () => {
  try {
    await signOut(auth);
    console.log("Sesión cerrada correctamente");
  } catch (error) {
    console.error("Error al cerrar sesión:", error);
  }
};

// Exporta los métodos necesarios para interactuar con Firestore y Authentication
export { 
  db, 
  auth, 
  provider, 
  addDoc,
  collection, 
  query,
  doc, 
  setDoc, 
  deleteDoc,
  writeBatch,
  getDoc, 
  orderBy,
  where,
  updateDoc, 
  onSnapshot, 
  Timestamp, 
  getDocs, 
  signInWithGoogle, 
  getUserFromRedirect,  // Exportar la función de redirección
  logout 
};
